/**
 * Get array of date strings (YYYY-MM-DD) between start and end inclusive.
 * Uses local date parts to avoid timezone shifts (API returns YYYY-MM-DD in local context).
 */
function toLocalDateString(d: Date): string {
	const y = d.getFullYear();
	const m = String(d.getMonth() + 1).padStart(2, "0");
	const day = String(d.getDate()).padStart(2, "0");
	return `${y}-${m}-${day}`;
}

export function getDatesBetween(start: Date, end: Date): string[] {
	const dates: string[] = [];
	const current = new Date(start);
	current.setHours(0, 0, 0, 0);
	const endDate = new Date(end);
	endDate.setHours(0, 0, 0, 0);

	while (current <= endDate) {
		dates.push(toLocalDateString(current));
		current.setDate(current.getDate() + 1);
	}

	return dates;
}
